customElements.define('custom-builder-kit-form', class extends HTMLElement {
    constructor() {
        super();

        this.products = this.querySelector('.custom-builder-form__products');
        this.accesories = this.querySelector('.custom-builder-form__accessories');
        this.travelPack = this.querySelector('.travel-pack');
        this.submitButton = this.querySelector('.bundle-add-to-cart');
        this.otherSectionId = ""
        this.parentProductId = this.dataset.productId;

        this.switchers = this.querySelectorAll('.custom-builder-form__switcher');
        this.switchers.forEach(switcher => {
            switcher.addEventListener('click', this.handleSwitcherClick.bind(this));
        });

        console.log("Init item")

        !this.otherSectionId && this.init()

        this.submitButton.addEventListener('click', this.handleClick.bind(this));
    }

    init(){
        fetch(this.switchers[1].dataset.url)
        .then(response => {
            return response.text();
        })
        .then(res => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(res, "text/html");
            this.otherSectionId = doc.querySelector('.product-template').dataset.sectionId;
        })
    }

    handleClick(event) {
        event.preventDefault();
        const kitRandomId = new Date().getTime();
        const selectedFlavour = parseInt(this.querySelector('input[name="builder-flavour"]:checked').value);

        const data = {
            items: [
                {
                    id: parseInt(this.parentProductId),
                    quantity: 1,
                    properties: {
                        "_kit_parent_id": kitRandomId,
                        "_kit_flavour": selectedFlavour,
                        "_kit_accessory_1": parseInt(Array.from(this.querySelectorAll('.custom-builder-form__accessory'))[0].dataset.variantId),
                        "_kit_accessory_2": parseInt(Array.from(this.querySelectorAll('.custom-builder-form__accessory'))[1].dataset.variantId),
                        "_kit_travel_pack": parseInt(this.travelPack.dataset.productId)
                    }
                },
                // {
                //     id: selectedFlavour,
                //     quantity: 1,
                //     parent_id: parseInt(this.parentProductId),
                //     properties: {
                //         "_kit_child_id": kitRandomId
                //     }
                // },
                // ...accesoriesData
            ]
        }
        /*if(this.travelPack){
            data.items.push({
                id: parseInt(this.travelPack.dataset.productId),
                quantity: 1,
                parent_id: parseInt(this.parentProductId),
                properties: {
                    "_kit_child_id": kitRandomId
                }
            })
        }*/

        const cartDrawer = document.querySelector('m-cart-drawer').dataset.section;
        const cart = document.querySelector('m-cart-drawer');

        const payload = {
            items: data.items,
            sections: cartDrawer
        };

        fetch(window.MinimogSettings.routes.cart_add_url+".js", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            cart.renderContents(data);
        })
        .catch(error => {
            console.error('Error adding items to cart:', error);
        });
    }


    handleSwitcherClick(event) {
        event.preventDefault();
        const url = event.target.dataset.url;
        const sectionId = this.otherSectionId //this.closest('.shopify-section').id;
        if(!sectionId) return
        fetch(url+"?section_id="+sectionId)
        .then(response => {
            return response.text();
        })
        .then(res => {
            const newPdp = document.createElement("html")
            newPdp.innerHTML = res
            const newPdpWrapper = newPdp.querySelector('.product-template')
            const currentPdp = this.closest('.product-template')
            currentPdp.parentNode.replaceChild(newPdpWrapper, currentPdp)
            currentPdp.querySelector('custom-builder-form')?.initializePreselectedQuantities();
            window.history.pushState({}, "", url)
        })
        .catch(error => {
            console.error('Error fetching products:', error);
        });
    }
});


customElements.define('custom-builder-microbiokit', class extends HTMLElement {
    constructor() {
        super();

        this.products = this.querySelectorAll('.custom-builder-form__product');
        this.accesories = this.querySelector('.custom-builder-form__accessories');
        this.travelPack = this.querySelector('.travel-pack');
        this.submitButton = this.querySelector('.bundle-add-to-cart');
        this.plusButtons = this.querySelectorAll('.custom-builder-form__product-quantity .plus');
        this.minusButtons = this.querySelectorAll('.custom-builder-form__product-quantity .minus');
        this.parentProductId = this.dataset.productId;
        this.atcText = this.submitButton.querySelector('.atc-text').innerHTML
        this.stickyAtc = document.querySelector('.prod__sticky-atc')
        this.stickyAtcButton = this.stickyAtc.querySelector('.add-to-cart')
        this.totalQuantity = 0;
        this.flavors = [];
        
        
        //Hide sticky on load
        this.stickyAtc.classList.add("hide-sticky")

        //Show once the user has scrolled past the form
        const observer = new IntersectionObserver(
            (entries) => {
            entries.forEach((entry) => {
                // We check if the element is NOT intersecting AND the bounding box is above the viewport
                if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                    this.stickyAtc.classList.remove("hide-sticky")
                }else{
                    this.stickyAtc.classList.add("hide-sticky")
                }
            });
            },
            { threshold: 0 } // trigger when even 1px is visible/not visible
        );

        observer.observe(this.submitButton);

        this.handleQuantityChange()


        this.plusButtons.forEach(button => {
            button.addEventListener('click', this.handlePlusClick.bind(this));
        });

        this.minusButtons.forEach(button => {
            button.addEventListener('click', this.handleMinusClick.bind(this));
        });

        this.submitButton.addEventListener('click', this.handleClick.bind(this));
        this.stickyAtcButton.addEventListener('click', (e)=>{
            e.preventDefault()
            window.scrollTo({
                top: this.getBoundingClientRect().top + window.scrollY - 100,
                behavior: 'smooth'
            })
        });
    }

    handleClick(event) {
        event.preventDefault();
        const kitRandomId = new Date().getTime();

        const non0Items = Array.from(this.products).filter(product => {
            console.log(product)
            const quantityInput = product.querySelector('.custom-builder-form__product-quantity input');
            return quantityInput.value > 0;
        });

        const flavours = [];

        non0Items.forEach(item => {
            flavours.push(parseInt(item.querySelector('input[name="variant_id"]').value));
        });

        const data = {
            items: [
                {
                    id: parseInt(this.parentProductId),
                    quantity: 1,
                    properties: {
                        "_microbiokit_parent_id": kitRandomId, 
                        "_microbiokit_first_flavour": flavours[0],
                        "_microbiokit_second_flavour": flavours[1] || flavours[0],
                        "_microbiokit_accessory_1": 55718533202295,
                        //"_microbiokit_accessory_1": parseInt(Array.from(this.querySelectorAll('.custom-builder-form__accessory'))[0].dataset.variantId),
                        //"_microbiokit_accessory_2": parseInt(Array.from(this.querySelectorAll('.custom-builder-form__accessory'))[1].dataset.variantId),
                    }
                }
            ]
        }

        const cartDrawer = document.querySelector('m-cart-drawer').dataset.section;
        const cart = document.querySelector('m-cart-drawer');

        const payload = {
            items: data.items,
            sections: cartDrawer
        };

        fetch(window.MinimogSettings.routes.cart_add_url+".js", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            cart.renderContents(data);
        })
        .catch(error => {
            console.error('Error adding items to cart:', error);
        });
    }


    handlePlusClick(event) {
        const product = event.target.closest('.custom-builder-form__product');
        const quantityInput = product.querySelector('.custom-builder-form__product-quantity input');
        quantityInput.value = parseInt(quantityInput.value) + 1;
        product.classList.add('custom-builder-form__product--active');
        this.totalQuantity += 1
        this.handleQuantityChange()
    }

    handleMinusClick(event) {
        const product = event.target.closest('.custom-builder-form__product');
        const quantityInput = product.querySelector('.custom-builder-form__product-quantity input');
        if (quantityInput.value > 0) {
            quantityInput.value = parseInt(quantityInput.value) - 1;
            if(quantityInput.value == 0){
                product.classList.remove('custom-builder-form__product--active');
            }
            this.totalQuantity -= 1
        }
        this.handleQuantityChange()
    }

    handleQuantityChange(){
        console.log("handle quantity change")
        if(this.totalQuantity >= 2){
            this.plusButtons.forEach(button => {
                button.disabled = true;
                button.style.opacity = 0.3;
                button.style.pointerEvents = 'none';
            });
        }else{
            this.plusButtons.forEach(button => {
                button.disabled = false;
                button.style.opacity = 1;
                button.style.pointerEvents = 'auto';
            });
        }
        if(this.totalQuantity == 0){
            this.submitButton.querySelector('.atc-text').innerHTML = "Añade 2 unidades"
            //this.stickyAtcButton.querySelector('.atc-text').innerHTML = "Añade 2 unidades"
        }else if(this.totalQuantity == 1){
            this.submitButton.querySelector('.atc-text').innerHTML = "Añade 1 unidad más"
            //this.stickyAtcButton.querySelector('.atc-text').innerHTML = "Añade 1 unidad más"
        }else{
            this.submitButton.querySelector('.atc-text').innerHTML = this.atcText
            //this.stickyAtcButton.querySelector('.atc-text').innerHTML = this.atcText
        }
        this.querySelector('.bundle-add-to-cart').disabled = !(this.totalQuantity == 2)
        //this.stickyAtcButton.disabled = !(this.totalQuantity == 2)
    }
});




document.addEventListener('DOMContentLoaded', function() {
    customElements.define('custom-builder-form-fitblend', class extends HTMLElement {
        constructor() {
            super();
            
            this.products = this.querySelectorAll('.custom-builder-form__product');
            this.accessories = this.querySelectorAll('.custom-builder-form__accessory');
            this.quantityInputs = this.querySelectorAll('.custom-builder-form__product-quantity input');
            this.plusButtons = this.querySelectorAll('.custom-builder-form__product-quantity .plus');
            this.minusButtons = this.querySelectorAll('.custom-builder-form__product-quantity .minus');
            this.submitButton = this.querySelector('.bundle-add-to-cart');
            this.bundleTotalPrice = 0
            this.otherSectionId = ""
            this.accessoryCheckboxes = this.querySelectorAll('input[name="accessory"]');
            this.totalQuantity = 0
            this.hasTravelPack = this.querySelector('.travel-pack') ? true : false;

            this.switchers = this.querySelectorAll('.custom-builder-form__switcher');
            this.switchers.forEach(switcher => {
                switcher.addEventListener('click', this.handleSwitcherClick.bind(this));
            });

            !this.otherSectionId && this.init()

            this.plusButtons.forEach(button => {
                button.addEventListener('click', this.handlePlusClick.bind(this));
            });

            this.minusButtons.forEach(button => {
                button.addEventListener('click', this.handleMinusClick.bind(this));
            });

            this.accessoryCheckboxes.forEach(checkbox => {
                checkbox.addEventListener('change', (e) => {
                    // If this checkbox was just checked
                    if (e.target.checked) {
                        // Uncheck all other checkboxes
                        this.accessoryCheckboxes.forEach(otherCheckbox => {
                            if (otherCheckbox !== e.target) {
                                otherCheckbox.checked = false;
                            }
                        });
                    }
                    this.handlePriceChange();
                    this.handleSummaryChange();
                });
            });

            this.submitButton.addEventListener('click', this.handleSubmitClick.bind(this));
            
            // Initialize preselected quantities
            this.initializePreselectedQuantities();
        }

        init(){
            fetch(this.switchers[1].dataset.url)
            .then(response => {
                return response.text();
            })
            .then(res => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(res, "text/html");
                this.otherSectionId = doc.querySelector('.product-template').dataset.sectionId;
            })
        }

        handleSwitcherClick(event) {
            event.preventDefault();
            const url = event.target.dataset.url;
            const sectionId = this.otherSectionId //this.closest('.shopify-section').id;
            if(!sectionId) return
            fetch(url+"?section_id="+sectionId)
            .then(response => {
                return response.text();
            })
            .then(res => {
                const newPdp = document.createElement("html")
                newPdp.innerHTML = res
                const newPdpWrapper = newPdp.querySelector('.product-template')
                const currentPdp = this.closest('.product-template')
                currentPdp.parentNode.replaceChild(newPdpWrapper, currentPdp)
                window.history.pushState({}, "", url)
            })
            .catch(error => {
                console.error('Error fetching products:', error);
            });
        }

        initializePreselectedQuantities() {
            this.totalQuantity = 0;
            this.products.forEach(product => {
                const quantityInput = product.querySelector('.custom-builder-form__product-quantity input');
                const quantity = parseInt(quantityInput.value);
                if (quantity > 0) {
                    product.classList.add('custom-builder-form__product--active');
                    this.totalQuantity += quantity;
                }
            });
            this.handlePriceChange();
            this.handleQuantityChange();
        }

        handlePlusClick(event) {
            const product = event.target.closest('.custom-builder-form__product');
            const quantityInput = product.querySelector('.custom-builder-form__product-quantity input');
            quantityInput.value = parseInt(quantityInput.value) + 1;
            product.classList.add('custom-builder-form__product--active');
            this.totalQuantity += 1
            this.handlePriceChange()
            this.handleQuantityChange()
        }

        handleMinusClick(event) {
            const product = event.target.closest('.custom-builder-form__product');
            const quantityInput = product.querySelector('.custom-builder-form__product-quantity input');
            if (quantityInput.value > 0) {
                quantityInput.value = parseInt(quantityInput.value) - 1;
                if(quantityInput.value == 0){
                    product.classList.remove('custom-builder-form__product--active');
                }
                this.totalQuantity -= 1
            }
            this.handlePriceChange()
            this.handleQuantityChange()
        }

        handlePriceChange() {
            this.bundleTotalPrice = 0
            var totalQuantity = 0
            var discount = 0
        
            // Calculate main products total
            this.products.forEach(product => {
                const quantityInput = product.querySelector('.custom-builder-form__product-quantity input');
                if(quantityInput.value > 0) {
                    totalQuantity += parseInt(quantityInput.value)
                    const price = parseFloat(product.querySelector('.custom-builder-form__product-quantity input').dataset.price);
                    this.bundleTotalPrice += price * quantityInput.value;
                }
            })
        
            // Apply quantity discount to match your HTML
            if (totalQuantity >= 6) {
                discount = 20;
            } else if (totalQuantity === 5) {
                discount = 16;
            } else if (totalQuantity === 4) {
                discount = 14;
            } else if (totalQuantity === 3) {
                discount = 12;
            } else if (totalQuantity === 2) {
                discount = 10;
            } else if (totalQuantity === 1) {
                discount = 0; // Single unit gets 10% discount
            }
            
            this.bundleTotalPrice = Number((this.bundleTotalPrice * ((100 - discount) / 100)).toFixed(2))
        
            // Add accessory price (which is already discounted)
            const accessory = this.querySelector('input[name="accessory"]:checked');
            if(accessory) {
                this.bundleTotalPrice += parseFloat(accessory.dataset.price);
            }
        
            this.submitButton.querySelector('.atc-price').textContent = this.bundleTotalPrice.toFixed(2) + "€ - ";
            this.handleSummaryChange()
        }

        handleSummaryChange(){
                var summaryHtml = ""
                var accessoryHtml = ""

                // Calculate main products total price
                var totalOriginalPrice = 0;
                var totalQuantity = 0;

                this.products.forEach(product => {
                    const quantityInput = product.querySelector('.custom-builder-form__product-quantity input');
                    const quantity = parseInt(quantityInput.value);
                    if(quantity > 0) {
                        const price = parseFloat(quantityInput.dataset.price);
                        totalOriginalPrice += price * quantity;
                        totalQuantity += quantity;
                        summaryHtml += "x" + quantity + " " + quantityInput.dataset.title + "<br>"
                    }
                })

                // Calculate quantity-based discount
                var discount = 0;
                if (totalQuantity >= 6) {
                    discount = 20;
                } else if (totalQuantity === 5) {
                    discount = 16;
                } else if (totalQuantity === 4) {
                    discount = 14;
                } else if (totalQuantity === 3) {
                    discount = 12;
                } else if (totalQuantity === 2) {
                    discount = 10;
                } else if (totalQuantity === 1) {
                    discount = 0; // Single unit gets no discount
                }

                var totalDiscountedPrice = Number((totalOriginalPrice * ((100 - discount) / 100)).toFixed(2));

                // Update main product prices in summary
                if (discount > 0) {
                    // Show both original (crossed out) and discounted price when there's a discount
                    this.querySelector('.custom-builder-form__summary-price-original').textContent = totalOriginalPrice.toFixed(2) + '€';
                    this.querySelector('.custom-builder-form__summary-price-original').style.display = 'inline';
                    this.querySelector('.custom-builder-form__summary-price-discounted').textContent = totalDiscountedPrice + '€';
                } else {
                    // Show only the final price when there's no discount (1 unit)
                    this.querySelector('.custom-builder-form__summary-price-original').style.display = 'none';
                    this.querySelector('.custom-builder-form__summary-price-discounted').textContent = totalOriginalPrice.toFixed(2) + '€';
                }
                
                this.querySelector('.custom-builder-form__summary-item-value').innerHTML = summaryHtml;

                if(this.accessories.length > 0) {
                    const accessory = this.querySelector('input[name="accessory"]:checked');
                    if(accessory) {
                        const accessoryDiscountedPrice = parseFloat(accessory.dataset.price);
                        const accessoryDiscount = parseFloat(accessory.dataset.discount);
                        // Calculate original price by working backwards from the discounted price
                        const accessoryOriginalPrice = Number((accessoryDiscountedPrice / ((100 - accessoryDiscount) / 100)).toFixed(2));
                        
                        accessoryHtml += accessory.dataset.title + "<br>";
                        
                        // Update accessory prices in summary
                        this.querySelector('.custom-builder-form__summary-price-original--accessory').textContent = accessoryOriginalPrice.toFixed(2) + '€';
                        this.querySelector('.custom-builder-form__summary-price-discounted--accessory').textContent = accessoryDiscountedPrice.toFixed(2) + '€';
                    } else {
                        // Clear accessory prices when no accessory is selected
                        this.querySelector('.custom-builder-form__summary-price-original--accessory').textContent = '';
                        this.querySelector('.custom-builder-form__summary-price-discounted--accessory').textContent = '';
                    }
                }
                this.querySelector('.custom-builder-form__summary-item-title--accessory').innerHTML = accessoryHtml

                if(accessoryHtml != "" || summaryHtml != ""){
                    this.querySelector('.custom-builder-form__summary').classList.remove('hidden')
                }else{
                    this.querySelector('.custom-builder-form__summary').classList.add('hidden')
                }
            }


        handleQuantityChange(){
            const quantity = this.totalQuantity < 6 ? this.totalQuantity : 6
            this.querySelectorAll('.units-discount__item').forEach(item => {
                if(item.dataset.units == quantity){
                    item.classList.add('active')
                }else{
                    item.classList.remove('active')
                }
            })

            if(this.hasTravelPack && this.totalQuantity >= 2){
                this.querySelector('.travel-pack').classList.add('unlocked')
            }else{
                this.querySelector('.travel-pack').classList.remove('unlocked')
            }
        }

        handleSubmitClick(event) {
            event.preventDefault();
            event.stopPropagation();
            const bundleId = new Date().getTime()
            
            const non0Items = Array.from(this.products).filter(product => {
                const quantityInput = product.querySelector('.custom-builder-form__product-quantity input');
                return quantityInput.value > 0;
            });

            const items = [];

            non0Items.forEach(item => {
                items.push({
                    id: parseInt(item.querySelector('input[name="variant_id"]').value),
                    quantity: parseInt(item.querySelector('.custom-builder-form__product-quantity input').value),
                    properties: {
                        "_product_type_post_rebajas": item.dataset.group
                    }
                });
            });

            if(this.accessories.length > 0) {
                const accessory = this.querySelector('input[name="accessory"]:checked');
                if(accessory) {
                    items.push({
                        id: parseInt(accessory.value),
                        quantity: 1,
                        properties: {
                              "_fitblend_accessory": true,
                              "_fitblend_accessory_discount": parseInt(accessory.dataset.discount)
                        }
                    });
                }
            }

            const cartDrawer = document.querySelector('m-cart-drawer').dataset.section;
            const cart = document.querySelector('m-cart-drawer');

            const payload = {
                items: items,
                sections: cartDrawer
            };

            fetch(window.MinimogSettings.routes.cart_add_url+".js", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                cart.renderContents(data);
            })
            .catch(error => {
                console.error('Error adding items to cart:', error);
            });
            
            return false;
        }
    });
});





class CartUpsell extends HTMLElement {
    constructor(){
        super()

        this.variantId = this.dataset.variantId
        this.cart = this.closest('m-cart-drawer')
        this.addToCartButton = this.querySelector('.cart-upsells__item-add')
        this.addToCartButton.addEventListener('click', (e) => {
            e.preventDefault()
            this.addToCartButton.classList.add('atc-loading')
            this.addToCart()
        })
    }

    addToCart(){
        fetch(`/cart/add.js`, {
            method: 'POST',
            headers:{
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: this.variantId,
                quantity: 1,
                properties: {
                    "_product_type_post_rebajas": this.dataset.productType
                }
            })
        })
        .then(response => response.json())
        .then(response => {
            const sectionId = document.querySelector("m-cart-drawer").dataset.section || "cart-drawer"
            fetch(`/cart?section_id=${sectionId}`)
            .then(response => response.text())
            .then(data=>{
                console.log("TESTt")
                const html = new DOMParser().parseFromString(data, 'text/html')
                this.closest('.m-cart-drawer--inner').innerHTML = html.querySelector('.m-cart-drawer--inner').innerHTML
                console.log(this.cart)
                console.log(this.cart.querySelector('.m-cart-drawer--close-icon'))
                this.cart.querySelector('.m-cart-drawer--close-icon').addEventListener('click',()=>{
                    this.cart.close()
                });
                //TODO: Add eulerian data
                console.log("TEST")
                try {
                    const eulerianElement = document.getElementById('eulerian-items-data');
                    if (eulerianElement) {
                      const data = JSON.parse(eulerianElement.innerText);
                      console.log(data)
                      const eulerianData = ["path","" + window.location.pathname + ""];
                      
                      // Convert nested object to flat array
                      Object.entries(data.eulerianData).forEach(([key, value]) => {
                        if (key === 'products') {
                          // Handle products array
                          value.forEach(product => {
                            Object.entries(product).forEach(([prodKey, prodValue]) => {
                              eulerianData.push(prodKey, prodValue.toString());
                            });
                          });
                        } else {
                          eulerianData.push(key, value.toString());
                        }
                      });
                      eulerianData.push('upsell-carrito','add')
                      eulerianData.push('pais', window.userCountry || Shopify.country);
                      eulerianData.push('enopagedt', '1')
                      console.log('Eulerian data array:', eulerianData);
                      console.log(this.cart.querySelector('m-cart-drawer-items'))
                      //this.cart.querySelector('m-cart-drawer-items').addCartGift()
                      //this.cart.querySelector('m-cart-drawer-items').checkCartGift()
                      if (typeof EA_push === 'function') {
                        EA_push(eulerianData);
                      }
                    }
                  } catch (error) {
                    console.error('Error handling Eulerian data:', error);
                }
            })
        })
    }
}
customElements.define('cart-upsell', CartUpsell)

customElements.define('product-card-images', class extends HTMLElement {
    constructor() {
        super();
        this.images = Array.from(this.querySelectorAll('.spc__main-img'));
        this.dots = Array.from(this.querySelectorAll('.dot'));
        this.currentIndex = 0;
        this.intervalId = null;
        this.isMobile = window.innerWidth < 768;

        this.setupEventListeners();
        this.setupTouchEvents();
    }

    setupEventListeners() {
        if (!this.isMobile) {
            this.addEventListener('mouseenter', this.startSlider);
            this.addEventListener('mouseleave', this.stopSlider);
        }

        this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => this.goToImage(index));
        });

        window.addEventListener('resize', this.handleResize);
    }

    setupTouchEvents() {
        let startX, moveX;
        this.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
        });

        this.addEventListener('touchmove', (e) => {
            moveX = e.touches[0].clientX;
        });

        this.addEventListener('touchend', () => {
            if (startX + 50 < moveX) {
                this.showPreviousImage();
            } else if (startX - 50 > moveX) {
                this.showNextImage();
            }
        });
    }

    handleResize = () => {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth < 768;
        if (wasMobile !== this.isMobile) {
            this.stopSlider();
            this.setupEventListeners();
        }
    }

    startSlider = () => {
        if (this.images.length <= 1 || this.isMobile) return;
        
        this.showNextImage();
        
        this.intervalId = setInterval(() => {
            this.showNextImage();
        }, 2000);
    }

    stopSlider = () => {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    showNextImage = () => {
        this.goToImage((this.currentIndex + 1) % this.images.length);
    }

    showPreviousImage = () => {
        this.goToImage((this.currentIndex - 1 + this.images.length) % this.images.length);
    }

    goToImage(index) {
        this.images[this.currentIndex].classList.remove('active');
        this.dots[this.currentIndex].classList.remove('active');
        this.currentIndex = index;
        this.images[this.currentIndex].classList.add('active');
        this.dots[this.currentIndex].classList.add('active');
    }
});